import React, { useState } from 'react';
import { Input, Modal, message } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import { _set_safe_verify_data } from '../../store/Action';
import HTTP from '../../script/service';
import './index.scss';

const SafeVerifyInputModal = ({ base }) => {
  const { uid, safeVerifyConfig = null } = base;
  const [value, setValue] = useState('');

  const hideModal = () => {
    setValue('');
    _set_safe_verify_data(false, null);
  };

  // 提交
  const onSubmit = () => {
    // todo 如果需要自动再次发送请求，则打开以下注释
    // safeVerifyConfig.config.data.safePassword = value;
    // service(safeVerifyConfig.config);
    HTTP._check_user_safe_pwd({ safePassword: value, uid }).then((res) => {
      if (res?.code === 200) {
        if (res.data) {
          hideModal();
        } else {
          message.warning('验证失败，请检查安全码是否正确');
        }
      } else {
        message.error(res?.message || '操作失败，请稍后重试哦~');
      }
    });
  };

  return (
    <Modal
      open={safeVerifyConfig?.visible}
      wrapClassName="daidai-modal-style has-top-border"
      centered={true}
      title="验证消费密码"
      width={400}
      destroyOnHidden
      keyboard={false}
      maskClosable={false}
      onCancel={hideModal}
      onOk={onSubmit}
      zIndex={1009}
    >
      <div className="safe-modal-content">
        <Input
          className="safe-input"
          type={'text'}
          prefix={<LockOutlined />}
          value={value}
          autoComplete="off"
          onChange={({ target: { value } }) => setValue(value)}
        />
      </div>
    </Modal>
  );
};

export default connect((store) => ({ base: store }))(SafeVerifyInputModal);
